import { oneOf } from 'prop-types';
import React from 'react';
import { Badge } from 'reactstrap';

import { COLORS } from '../utils/constants';
import { APPROVAL_STATUSES } from './constants';

export const BADGE_COLORS = {
  [APPROVAL_STATUSES.PENDING]: COLORS.PRIMARY,
  [APPROVAL_STATUSES.GRANTED]: COLORS.SUCCESS,
  [APPROVAL_STATUSES.DENIED]: COLORS.DANGER,
};

function ApprovalStatus({ status, ...rest }) {
  return (
    <Badge color={BADGE_COLORS[status]} {...rest}>
      {status}
    </Badge>
  );
}

ApprovalStatus.propTypes = {
  status: oneOf(Object.keys(BADGE_COLORS)).isRequired,
};

export default ApprovalStatus;
